import React, { Component } from 'react';
import { Animated } from "react-animated-css";
import axios from 'axios';
import {Link} from 'react-router-dom';

import LocationForm from '../../components/LocationForm';
import Header from '../../components/Header/Header';
import {  
          REMOVE_LOCATION, 
          NOTIFICATIONS, 
          ERROR_MESSAGES,  
          EMBED_BUTTON_IMG 
} from '../../config';

const SAMPLE_BUTTON_WIDTH = "215px";

class Locations extends Component {
  constructor(props){
    super(props);
    if(!this.props.client){
      this.props.updateClient();
    }
    this.state = {
      addLocation: false,
      delete: false,
      edit: false,
      notification: '',
      error: '',
      editingLocation: false,
      dietaryPolicy: null,
      dietTagVector: null,
    }

    this.updateClient = this.updateClient.bind(this);
    this.doneAddingLocation = this.doneAddingLocation.bind(this);
    this.cancelAddingLocation = this.cancelAddingLocation.bind(this);
    this.cancelEditingLocation = this.cancelEditingLocation.bind(this);
    this.doneEditingLocation = this.doneEditingLocation.bind(this);
  }

  /**
   * API call to delete a location
   * @param id : _id of restaurant to delete
   */
  deleteLocation(id){
    let self = this;
    axios.post(
        REMOVE_LOCATION(id),
        {},
        {
          headers: {
            "Authorization": self.props.client.token,
            "Content-Type": "application/json"
          }
        }
    ).then(function(response){
        self.props.updateActiveLocation(0);
        self.props.updateClient();
        self.handleShowNotification(NOTIFICATIONS.LOCATION_DELETED);
        self.deleteToggle();
    }).catch(function(err){
        self.setState({error: ERROR_MESSAGES.NO_DELETE});
        self.deleteToggle();
    })    
  }


  updateClient(){
    this.props.updateClient();
  }

  doneAddingLocation(){
    this.setState({addLocation: false, error: ''});
    this.handleShowNotification(NOTIFICATIONS.LOCATION_ADDED);
  }

  doneEditingLocation(){
    this.setState({editingLocation: false});
    this.handleShowNotification(NOTIFICATIONS.LOCATION_EDITED);
  }


  cancelAddingLocation(){
    this.setState({addLocation: false});
  }

  cancelEditingLocation(){
    this.setState({editingLocation: false});
  }

  handleShowNotification(notification){
      this.setState({
          notification
      });
      setTimeout(() => {
        this.setState({notification: ''});
      }, 10000);
  }
  
  

 
  deleteToggle(){
    this.setState({delete: !this.state.delete});
  }

  editLocation(){
    this.setState({editingLocation: true});
  }

  get deleteDialogueBox(){
    if(!this.state.delete) return null;
    if(this.props.client && this.props.client.locations){ 
      return(
        <div className="dialogueBoxContainer">
            <div className="clickArea" onClick = {() => this.deleteToggle()}>
              &nbsp;
            </div>
            <div className={`dialogueBox ${!document.body.classList.contains('sidebar-minimized') ? 'sideBarOn' : ''}`}>
              <div className="prompt">
                <p> Are you sure you want to <em>DELETE</em> this Location?</p>
                <p id="question"> {this.props.client.locations[this.props.activeLocation]["name"]} , {this.props.client.locations[this.props.activeLocation]["address"]} </p>
              </div>
              <div className="input">
                <div className="greenLink" onClick = {() => this.deleteToggle()}> Keep </div>
                <div className="redLink" onClick={()=> this.deleteLocation(this.props.client.locations[this.props.activeLocation]["_id"])}> Remove </div>
              </div>
            </div>
        </div>
      )
    }
    else return null;
  }

  /**
    * Opens webapp for this restaurant
  */
  buttonClickHandler() {
      window.open("https://app.honeycomb.ai/" + this.props.client.locations[this.props.activeLocation]["shortURL"], "_blank");
  }
 
  get renderNotification(){
    let style;
    if(this.state.notification != ''){
        style = "ErrorGreen";
    } else if(this.state.error != ''){
        style = "ErrorRed";
    }
    
    return style && (
        <Animated 
            animationIn="shake" 
            animationOut="fadeOut" 
            isVisible={true}
            >
                <div className="RegistrationCard" id={style} >
                  <div className="RegistrationCardBody">
                      {this.state.notification}
                  </div>
                </div>
        </Animated>
    );
  }

  get locationListRender() {
    if(this.props.client && this.props.client.locations && this.props.client.locations.length > 0){
    return (
      <div className="row">
        <div className="dashboardCard">
          <div className="dashboardCardBody">
            <div className="row noMargin">
              <div className="column-half">
                <div className="dashboardCardHeading">Select or Add a Location</div>
              </div>
              <div className="top-right">
                <button
                    className="btn btn-success btn-lg"
                    id="add-location-button"
                    onClick={() => this.maxLocationChecker()}
                  >
                    <i className="fa fa-plus"></i>&nbsp; Add Location
                  </button>
              </div>
              <div className="row noMargin">
                <div className="column-half">
                  <div className="list-group restaurantList">
                    <ul>
                      {this.restaurantList}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )}
    else if (this.props.client && this.props.client.locations && this.props.client.locations.length == 0){
      return(
        <div className="row">
          <div className="dashboardCard">
            <div className="dashboardCardBody">
              <p className="centered-row"> Added Locations will appear here.</p>
            </div>
          </div>
        </div>
      )
    }
  }


  get restaurantList(){
    if (!this.props.client || !this.props.client.locations) return null;
    let restaurantList = [];
    for(let i =0; i<this.props.client.locations.length; i++){
      if (i == this.props.activeLocation){
        restaurantList.push(
          <span 
            className="active list-group-item-action list-group-item"
            key={i}
          >
            {this.props.client.locations[i]["name"] + ' | ' + 
              this.props.client.locations[i]["address"]}
          </span>
        )
      }
      else {
        restaurantList.push(
          <span 
            className="list-group-item-action list-group-item"
            key={i}
            onClick={()=>this.props.updateActiveLocation(i)}
          >
            {this.props.client.locations[i]["name"] + ' | ' + 
              this.props.client.locations[i]["address"]}
          </span>
        )
      }
    }
    return restaurantList;
  }

 get locationAdder(){
    if(!this.props.client) return null;
    return (
      <LocationForm 
        client = {this.props.client}
        updateClient = {this.props.updateClient}
        cancelAddingLocation = {this.cancelAddingLocation}
        doneAddingLocation = {this.doneAddingLocation}
        locationMax = {this.props.client.paidLocations}
        locations = {this.props.client.locations.length}
        editLocation = {false}
      />
    )
  }

  get locationEditor(){
    if(!this.props.client) return null;
    let locationProperties = {
      name : this.props.client.locations[this.props.activeLocation]["name"],
      address: this.props.client.locations[this.props.activeLocation]["address"],
      _id : this.props.client.locations[this.props.activeLocation]["_id"]
    }
    return (
      <LocationForm
        client = {this.props.client}
        updateClient = {this.props.updateClient}
        cancelAddingLocation = {this.cancelEditingLocation}
        doneAddingLocation = {this.doneEditingLocation}
        locationMax = {this.props.client.paidLocations}
        locations = {this.props.client.locations.length}
        locationProperties = {locationProperties}
        editLocation = {true}
      />
    )
  }

  maxLocationChecker(){
    if(this.props.client.locations.length < this.props.client.paidLocations ){
        this.setState({ addLocation: true }); 
    }
    else{
       this.setState({error:''});
       this.handleShowNotification(NOTIFICATIONS.LOCATION_UPGRADE);
    }
  }

  get header(){
    return(
      <Header
        pageName="LOCATIONS"
      />
    )
  }

  get selectedLocationsCard(){
    if(this.props.client && this.props.client.locations && this.props.client.locations.length > 0){
      return(
        <div className="row">
          <div className="dashboardCard">
            <div className="dashboardCardBody">
                <div className="row noMargin" >
                  <div className="column-half">
                    <div className="dashboardCardHeading" id="selectedLocation">
                      Selected Location
                    </div>
                      <div className="marginLine">
                        <div className="formTitle">Name: </div> <div className="displayText">{this.props.client.locations[this.props.activeLocation]["name"]}</div>
                      </div>
                      <div className="marginLine">
                        <div className="formTitle">Address:</div> <div className="displayText">{this.props.client.locations[this.props.activeLocation]["address"]}</div>
                      </div>
                      <button className="previewMenu" onClick={()=>this.buttonClickHandler()}>
                          Preview Menu
                      </button>
                      <Link to="/menu/verify">
                        <div className="verifyButton" >
                            Verify Menu
                        </div>
                      </Link>
                      
                  </div>
                  <div className="top-right">
                    <div className="greenLink" onClick={() => this.editLocation()}>edit</div> 
                    <div className="redLink" onClick={() => this.deleteToggle()}>delete</div>
                  </div>
                </div>
              </div>
          </div>
        </div>
      )
    }
    else if (this.props.client && this.props.activeLocation == 0){
      return(
        <div className="row">
          <div className="dashboardCard" id="bigButton">
            <div className="dashboardCardBody" onClick={() => this.maxLocationChecker()}>
              <p className="centered-row" id="emphasizedText"> Click To Add a Location and Get Started </p>
            </div>
          </div>
        </div>
      )
    }
  }


  render() {
    if(this.state.addLocation){
      return (
        this.locationAdder
      )
    }

    if(this.state.editingLocation){
      return (
        this.locationEditor
      );
    }

    return (
        <div>
          {this.deleteDialogueBox}
        <div className="animated fadeIn">
          {this.header}
          <div className="pageContainer">
              <div className="row noMargin">
                {this.renderNotification}
              </div>
              {this.selectedLocationsCard}
              {this.locationListRender}
          </div>
        </div>
        </div>
    )
  }
}

export default Locations;



// WEBPACK FOOTER //
// ./src/views/Locations/Locations.js